import { render, staticRenderFns } from "./breadCrumb.vue?vue&type=template&id=0529cc0c&scoped=true&"
import script from "./breadCrumb.vue?vue&type=script&lang=ts&"
export * from "./breadCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./breadCrumb.vue?vue&type=style&index=0&id=0529cc0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0529cc0c",
  null
  
)

export default component.exports